/*------------------------------------*\
	#RANGE SLIDER
\*------------------------------------*/

function initRangeSlider() {

	const range = '.js-range',
		rangeSlider = '.js-range-slider',
		rangeSliderDot = '.js-range-slider-dot',
		rangeInput = '.js-range-input',
		inputGroup = '.js-input-group',
		elementRanges = document.querySelectorAll(range);

	if (elementRanges) {

		elementRanges.forEach(elementRange => {

			const elementRangeSlider = elementRange.querySelector(rangeSlider),
				elementRangeSliderDots = elementRange.querySelectorAll(rangeSliderDot),
				elementRangeInput = elementRange.closest(inputGroup).querySelector(rangeInput);

			let rangeInputValue = elementRangeInput.value

			if (rangeInputValue !== 0) {
				updateRangeSlider(elementRange, elementRangeInput, rangeInputValue)
			}

			elementRangeSlider.addEventListener("change", () => {

				elementRangeSliderDots.forEach((elementRangeDot, i) => {

					if (elementRangeSlider.value >= i) {
						elementRangeDot.classList.add('is-selected');
						elementRangeInput.value = elementRangeDot.getAttribute('data-value')
					} else {
						elementRangeDot.classList.remove('is-selected');
					}

				})

			});

			elementRangeInput.addEventListener("blur", () => {
				let rangeInputValue = parseInt(elementRangeInput.value);

				updateRangeSlider(elementRange, elementRangeInput, rangeInputValue)

			});

		})

	}
}

function updateRangeSlider(elementRange, elementRangeInput, rangeInputValue) {
	const rangeSlider = '.js-range-slider',
		rangeSliderDot = '.js-range-slider-dot',
		elementRangeSlider = elementRange.querySelector(rangeSlider),
		elementRangeSliderDots = elementRange.querySelectorAll(rangeSliderDot);

	elementRangeSliderDots.forEach((elementRangeDot, i) => {

		let rangeDotValue = parseInt(elementRangeDot.getAttribute('data-value'))

		if (rangeDotValue <= rangeInputValue) {
			elementRangeDot.classList.add('is-selected');
			elementRangeSlider.value = i;
		} else {
			elementRangeDot.classList.remove('is-selected');
		}

	});
}

window.addEventListener('DOMContentLoaded', (event) => {
	initRangeSlider();
});
